import { ErrorBoundary } from '../components/ui';
import { PayRunsScreen } from '../features/payRuns/PayRunsScreen';

export const PayRunsPage = () => (
  <ErrorBoundary title="Pay Runs unavailable" message="This page could not be displayed. Retrying reloads it from scratch.">
    <PayRunsScreen />
  </ErrorBoundary>
);
